import { Box, TextField, Typography, Stack, Backdrop, CircularProgress, TableCell, IconButton, ButtonGroup, Button, Tooltip, Chip } from "@mui/material";
import Header from "../Components/layout/Header";
import { useState, useEffect, useContext } from "react";
import { API } from "../conf";
import SorTableCheckable from "../Components/ui/sortable-checkable";
import { Edit, InfoOutlined, CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import { Context } from "../App";
import moment from "moment";
import 'moment/locale/fr';
import { COMPTES_DE_CHARGES } from "../asset/variables";

moment.locale('fr');

export default function EBPexport(journal) {
  const { updateConnect, exercice } = useContext(Context)

  const organisation = JSON.parse(sessionStorage.getItem('eglise'))
  const [load, setLoad] = useState(true)
  const [selected, setSelected] = useState('')
  const [clotures, setClotures] = useState([])
  const [eglises, setEglises] = useState([])
  const [cloture, setCloture] = useState()
  const [open, setOpen] = useState(false)
  const [action, setAction] = useState('')
  const [mois, setMois] = useState('')
  const [dispoMonths, setDispoMonths] = useState([])
  const [search, setSearch] = useState('')

  const [petiteCaisses, setPetiteCaisses] = useState([])
  const [ebpExports, setEbpExports] = useState([])
  const [cloturesAnnuelles, setCloturesAnnuelles] = useState([])
  const [selectedAnnuel, setSelectedAnnuel] = useState([])

  const currentUserNum = JSON.parse(sessionStorage.getItem('user'))?.num

  function getExportInfo(egliseNumber, type) {
    return ebpExports.filter(e => e.eglise === egliseNumber && e.type === type && e.user_num === currentUserNum)
      .sort((a, b) => new Date(b.date) - new Date(a.date))[0]
  }

  function fetchEbpExports(moisKey) {
    fetch(API.concat(`/ebp-exports/${moisKey}`), {
      method: 'GET',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') }
    }).then(async res => {
      if (res.status === 200) setEbpExports(await res.json())
    })
  }

  function trackExport(egliseNumbers, type) {
    fetch(API.concat('/ebp-exports'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      body: JSON.stringify({ eglises: egliseNumbers, mois, type })
    }).then(res => { if (res.status === 200) fetchEbpExports(mois) })
  }

  const table = [
    {header: "Église", sortable: true, sortBy:(el)=>el.eglise.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.eglise.nom}</TableCell>},
    {header: "Date de clôture", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><TableCell align="center" key={index}>{moment(row.date).format('LL')}</TableCell>},
    {header: "Dons", sortable: true, sortBy:(el)=>el.dons.length, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.dons.length}</TableCell>},
    {header: "Dépenses", sortable: true, sortBy:(el)=>el.depenses.length, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.depenses.length}</TableCell>},
    {header: "Versements", sortable: true, sortBy:(el)=>el.versements.length, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.versements.length}</TableCell>},
    {header: "Exporté", sortable: false, row: (row, index) => {
      const rapport = getExportInfo(row.eglise.number, 'rapport')
      const depenses = getExportInfo(row.eglise.number, 'depenses')
      return <TableCell key={index} sx={{minWidth:'200px'}} align='center'>
        <Stack spacing={0.5} alignItems='center'>
          <Tooltip title={rapport ? `${rapport.user_nom} — ${moment(rapport.date).format('DD/MM/YYYY HH:mm')}` : 'Pas encore exporté'}>
            <Stack direction='row' alignItems='center' spacing={0.5} sx={{cursor:'default'}}>
              {rapport ? <CheckCircle fontSize='small' color='success'/> : <RadioButtonUnchecked fontSize='small' color='disabled'/>}
              <Typography variant='caption' color={rapport ? 'success.main' : 'text.disabled'}>Rapport</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={depenses ? `${depenses.user_nom} — ${moment(depenses.date).format('DD/MM/YYYY HH:mm')}` : 'Pas encore exporté'}>
            <Stack direction='row' alignItems='center' spacing={0.5} sx={{cursor:'default'}}>
              {depenses ? <CheckCircle fontSize='small' color='success'/> : <RadioButtonUnchecked fontSize='small' color='disabled'/>}
              <Typography variant='caption' color={depenses ? 'success.main' : 'text.disabled'}>Dépenses</Typography>
            </Stack>
          </Tooltip>
        </Stack>
      </TableCell>
    }},
  ]

  function normalize(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
  }

  function get_searchable(item) {
    if(!item) return ''
    const eglise = item.eglise
    if(!eglise) return ''
    return eglise.nom+' '+eglise.adresse1+' '+eglise.adresse2+' '+eglise.zip_code+' '+eglise.commune
  }

  function manage_dialog(status, action) {
    setOpen(status); setAction(action)
    if (!status) {
      setCloture()
    } 
  }

  function downloadCSV(filename, columns, content) {
    const header = columns.map(c => `"${c.label}"`).join(';')
    const rows = content.map(row =>
      columns.map(c => {
        const val = c.value(row)
        if (val === undefined || val === null || val === '') return ''
        if (typeof val === 'number') return String(val).replace('.', ',')
        return `"${String(val).replace(/"/g, '""')}"`
      }).join(';')
    )
    const csv = [header, ...rows].join('\r\n')
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename + '.csv'
    a.click()
    URL.revokeObjectURL(url)
  }

  const tableAnnuel = [
    {header: "Église", sortable: true, sortBy: el => el.eglise.nom.toLowerCase(), row: (row, index) => <TableCell key={index} style={{textTransform:'capitalize'}}>{row.eglise.nom}</TableCell>},
    {header: "Mois clôturés", sortable: false, row: (row, index) => <TableCell align="center" key={index}>{row.clotures.length}/12</TableCell>},
    {header: "Dons", sortable: true, sortBy: el => el.clotures.reduce((a,c) => a+c.dons.length,0), row: (row, index) => <TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.clotures.reduce((a,c) => a+c.dons.length,0)}</TableCell>},
    {header: "Dépenses", sortable: true, sortBy: el => el.clotures.reduce((a,c) => a+c.depenses.length,0), row: (row, index) => <TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.clotures.reduce((a,c) => a+c.depenses.length,0)}</TableCell>},
  ]

  function exportRapport(content) {
    const columns = [
      { label: "Journal", value: () => 750 },
      { label: "Date", value: row => moment(row.date).endOf('month').format('DD/MM/YYYY') },
      { label: "Pièce", value: row => row.pièce },
      { label: "Numéro de compte", value: row => row.num_compte },
      { label: "Libellé", value: row => row.libelle },
      { label: "Débit", value: row => row.debit },
      { label: "Crédit", value: row => row.credit },
      { label: "Poste analytique", value: row => row.poste_analytique },
    ]
    downloadCSV("RAPPORT_" + new Date(mois).toLocaleString('fr-FR', { month: 'long' }), columns, content)
  }

  function exportRapportAnnuel(content) {
    const columns = [
      { label: "Journal", value: () => 750 },
      { label: "Date", value: () => `31/12/${exercice}` },
      { label: "Pièce", value: row => row.pièce },
      { label: "Numéro de compte", value: row => row.num_compte },
      { label: "Libellé", value: row => row.libelle },
      { label: "Débit", value: row => row.debit },
      { label: "Crédit", value: row => row.credit },
      { label: "Poste analytique", value: row => row.poste_analytique },
    ]
    downloadCSV(`RAPPORT_ANNUEL_${exercice}`, columns, content)
  }

  function exportDepensesAnnuel(content) {
    const columns = [
      { label: "Journal", value: row => row.journal || '' },
      { label: "Date", value: row => moment.utc(row.date).format('DD/MM/YYYY') },
      { label: "N° de facture", value: row => row.num_facture || '' },
      { label: "Numéro de compte", value: row => row.num_compte || '' },
      { label: "Libellé", value: row => row.libelle || '' },
      { label: "Débit", value: row => row.debit || '' },
      { label: "Crédit", value: row => row.credit || '' },
      { label: "mode de règlement", value: row => row.mode_reglement || '' },
      { label: "Poste analytique", value: row => row.poste_analytique || '' },
    ]
    downloadCSV(`JOURNAL_DEPENSES_ANNUEL_${exercice}`, columns, content)
  }

  function exportDepenses(content) {
    const columns = [
      { label: "Journal", value: row => row.journal || '' },
      { label: "Date", value: row => moment.utc(row.date).format('DD/MM/YYYY') },
      { label: "N° de facture", value: row => row.num_facture || '' },
      { label: "Numéro de compte", value: row => row.num_compte || '' },
      { label: "Libellé", value: row => row.libelle || '' },
      { label: "Débit", value: row => row.debit || '' },
      { label: "Crédit", value: row => row.credit || '' },
      { label: "mode de règlement", value: row => row.mode_reglement || '' },
      { label: "Poste analytique", value: row => row.poste_analytique || '' },
    ]
    downloadCSV("JOURNAL_DEPENSES_" + new Date(mois).toLocaleString('fr-FR', { month: 'long' }), columns, content)
  }

  async function getRapport() {
    setLoad(true)
    const selectedClotures = clotures.filter(c => selected.includes(c._id))
    fetch(API.concat('/clotures/rapport_lines'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      body: JSON.stringify({ dons: selectedClotures.map(c => c.dons).flat(), eglises: selectedClotures.map(c => c.eglise.number), exercice, mois })
    }).then(async response => {
      const token = response.headers.get('x-auth-token')
      if (response.status === 401) { sessionStorage.clear(); updateConnect(false); return }
      if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
      if (response.status === 200) {
        exportRapport(await response.json())
        trackExport(selectedClotures.map(c => c.eglise.number), 'rapport')
      }
    }).catch(err => console.error(err)).finally(() => setLoad(false))
  }

  async function getDepensesJrnl() {
    setLoad(true)
    fetch(API.concat('/clotures/depenses_journal'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      },body: JSON.stringify({depenses: clotures.filter(c=>selected.includes(c._id)).map(c=>c.depenses).flat(), eglises: clotures.filter(c=>selected.includes(c._id)).map(c=>c.eglise.number)})
    }).then(async response => {
      const token = response.headers.get('x-auth-token')
      if (response.status === 401) {
        sessionStorage.clear()
        updateConnect(false)
      } else {
        if (token && token !== sessionStorage.getItem('token') && token !== '') {
          sessionStorage.setItem('token', response.headers.get('x-auth-token'))
        }
        if (response.status === 200) {
          const {depenses, eglises, petiteCaisses, comptesBancaires} = await response.json()
          console.log(depenses)
          //traitement des données
          const content = depenses.map(depense => {
            const eglise = eglises.find(e => e.number === depense.eglise)
            const compteDeCharge = COMPTES_DE_CHARGES.find(c => c.libelle === depense.class)?.num_compte || ''
            const rows = Object.entries(depense.paymode).filter(([mode, info]) => info > 0 || info.length >0 || (typeof info === 'object'&& !Array.isArray(info))).map(([mode, info]) => [
              {
                journal: mode === 'especes' ? 'es' : 'BP',
                date: depense.date,
                num_facture: depense.num_facture || '',
                num_compte: compteDeCharge.startsWith('7') ? comptesBancaires.find(c => c.eglise === depense.eglise)?.num_compte || '' : compteDeCharge,
                libelle: [eglise?.code_analytique, depense.fournisseur, depense.num_facture ? `F${depense.num_facture}` : null, depense.libelle].filter(Boolean).join(' - '),
                debit: mode === 'especes' ? info : mode==='cheques' ? info.reduce((acc, chq) => acc + (chq.montant || 0), 0) : info.montant || 0,
                mode_reglement: mode === 'especes' ? 'espèce' : mode === 'cheques' ? 'chèque' : mode === 'virement' ? 'vse' : mode === 'prelevement' ? 'pse' : mode,
                poste_analytique: eglise?.code_analytique || ''
              },
              {
                journal: mode === 'especes' ? 'es' : 'BP',
                date: depense.date,
                num_facture: depense.num_facture || '',
                num_compte: compteDeCharge.startsWith('7') ? compteDeCharge : (mode === 'especes' ? petiteCaisses : comptesBancaires).find(c => c.eglise === depense.eglise)?.num_compte || '',
                libelle: [eglise?.code_analytique, depense.fournisseur, depense.num_facture ? `F${depense.num_facture}` : null, depense.libelle].filter(Boolean).join(' - '),
                credit: mode === 'especes' ? info : mode==='cheques' ? info.reduce((acc, chq) => acc + (chq.montant || 0), 0) : info.montant || 0,
                mode_reglement: mode === 'especes' ? 'espèce' : mode === 'cheques' ? 'chèque' : mode === 'virement' ? 'vse' : mode === 'prelevement' ? 'pse' : mode,
                poste_analytique: eglise?.code_analytique || ''
              }
            ])
            
            return rows
          }).flat(2)

          setEglises(eglises)
          setPetiteCaisses(petiteCaisses)
          exportDepenses(content)
          trackExport(clotures.filter(c=>selected.includes(c._id)).map(c=>c.eglise.number), 'depenses')
        }
      }
    })
    .catch(err => console.error(err))
    .finally(() => setLoad(false))
  }

  async function getRapportAnnuel() {
    setLoad(true)
    const selected_groups = cloturesAnnuelles.filter(g => selectedAnnuel.includes(g._id))
    fetch(API.concat('/clotures/rapport_lines'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      body: JSON.stringify({ dons: selected_groups.flatMap(g => g.clotures.flatMap(c => c.dons)), eglises: selected_groups.map(g => g.eglise.number), exercice })
    }).then(async response => {
      const token = response.headers.get('x-auth-token')
      if (response.status === 401) { sessionStorage.clear(); updateConnect(false); return }
      if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
      if (response.status === 200) {
        exportRapportAnnuel(await response.json())
      }
    }).catch(err => console.error(err)).finally(() => setLoad(false))
  }

  async function getDepensesAnnuelJrnl() {
    setLoad(true)
    const selected_groups = cloturesAnnuelles.filter(g => selectedAnnuel.includes(g._id))
    const all_depenses = selected_groups.flatMap(g => g.clotures.flatMap(c => c.depenses))
    const all_eglises = selected_groups.map(g => g.eglise.number)
    fetch(API.concat('/clotures/depenses_journal'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      body: JSON.stringify({depenses: all_depenses, eglises: all_eglises})
    }).then(async response => {
      const token = response.headers.get('x-auth-token')
      if (response.status === 401) { sessionStorage.clear(); updateConnect(false); return }
      if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
      if (response.status === 200) {
        const {depenses, eglises, petiteCaisses, comptesBancaires} = await response.json()
        const content = depenses.map(depense => {
          const eglise = eglises.find(e => e.number === depense.eglise)
          const compteDeCharge = COMPTES_DE_CHARGES.find(c => c.libelle === depense.class)?.num_compte || ''
          return Object.entries(depense.paymode).filter(([mode, info]) => info > 0 || info.length > 0 || (typeof info === 'object' && !Array.isArray(info))).map(([mode, info]) => [
            { journal: mode === 'especes' ? 'es' : 'BP', date: depense.date, num_facture: depense.num_facture || '', num_compte: compteDeCharge.startsWith('7') ? comptesBancaires.find(c => c.eglise === depense.eglise)?.num_compte || '' : compteDeCharge, libelle: [eglise?.code_analytique, depense.fournisseur, depense.num_facture ? `F${depense.num_facture}` : null, depense.libelle].filter(Boolean).join(' - '), debit: mode === 'especes' ? info : mode==='cheques' ? info.reduce((acc, chq) => acc + (chq.montant || 0), 0) : info.montant || 0, mode_reglement: mode === 'especes' ? 'espèce' : mode === 'cheques' ? 'chèque' : mode === 'virement' ? 'vse' : mode === 'prelevement' ? 'pse' : mode, poste_analytique: eglise?.code_analytique || '' },
            { journal: mode === 'especes' ? 'es' : 'BP', date: depense.date, num_facture: depense.num_facture || '', num_compte: compteDeCharge.startsWith('7') ? compteDeCharge : (mode === 'especes' ? petiteCaisses : comptesBancaires).find(c => c.eglise === depense.eglise)?.num_compte || '', libelle: [eglise?.code_analytique, depense.fournisseur, depense.num_facture ? `F${depense.num_facture}` : null, depense.libelle].filter(Boolean).join(' - '), credit: mode === 'especes' ? info : mode==='cheques' ? info.reduce((acc, chq) => acc + (chq.montant || 0), 0) : info.montant || 0, mode_reglement: mode === 'especes' ? 'espèce' : mode === 'cheques' ? 'chèque' : mode === 'virement' ? 'vse' : mode === 'prelevement' ? 'pse' : mode, poste_analytique: eglise?.code_analytique || '' }
          ])
        }).flat(2)
        exportDepensesAnnuel(content)
      }
    }).catch(err => console.error(err)).finally(() => setLoad(false))
  }

  useEffect(()=>{
    if(mois){
      setLoad(true)
      setSelected([])
      fetchEbpExports(mois)

      fetch(API.concat(`/clotures/eglises/by`), {
        method:'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body: JSON.stringify(
          {
            isMonth: true, exercice, $and : [ {date: {
              $gte: new Date(exercice,Number(mois.split('-')[1])-1,1)
            }}, {date: {
              $lt: new Date((Number(mois.split('-')[0])=== 12 ? exercice+1 : exercice), (Number(mois.split('-')[0])=== 12 ? 0 : Number(mois.split('-')[1])),1)
            }}]
            
          }
        )
      }).then(async response=>{
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const json = await response.json();
            setClotures(json)
          } else {
            setClotures([])
            console.error('Erreur lors du chargement des clôtures', response.statusText)
            alert('Erreur lors du chargement des données')
          }
        }
      }).finally(()=> setLoad(false))
    }
  }, [mois])

  useEffect(()=>{
    if (!exercice) return
    fetch(API.concat('/clotures/eglises/by'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      body: JSON.stringify({isMonth: true, exercice})
    }).then(async response => {
      if (response.status === 200) {
        const json = await response.json()
        const byEglise = {}
        json.forEach(cloture => {
          const num = cloture.eglise?.number
          if (!num) return
          if (!byEglise[num]) byEglise[num] = {_id: cloture.eglise._id, eglise: cloture.eglise, clotures: []}
          byEglise[num].clotures.push(cloture)
        })
        setCloturesAnnuelles(Object.values(byEglise).filter(g => g.clotures.length === 12))
      }
    })
  }, [exercice])

  useEffect(()=>{
    if (!exercice) return
    fetch(API.concat(`/clotures/distinct_dates`), {
      method:'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }, body: JSON.stringify({exercice})
    }).then(async response=>{
      const token = response.headers.get('x-auth-token')
      if(response.status === 401) {
        sessionStorage.clear()
        updateConnect(false)
      }else {
        if (token && token !== sessionStorage.getItem('token') && token !== '') {
          sessionStorage.setItem('token', response.headers.get('x-auth-token'))
        }
        if (response.status === 200) {
          const json = await response.json()
          const dates = [...new Set(json.map(d => {
            const dateObj = new Date(d);
            return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}`;
          }))];
          setDispoMonths(dates.sort((a, b) => new Date(b) - new Date(a)))
        }
      }
    }).finally(()=> setLoad(false))
  }, [exercice])

  return(
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Header/>
      <Typography variant="h4" align="center" mt={3}>Module d'export pour EBP</Typography>

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', my: 2, px: 3 }}>
        <TextField select label="Mois" size="small" SelectProps={{ native: true}} InputLabelProps={{ shrink: true }} sx={{ width: 'auto', minWidth: 150 }}
        value={mois} onChange={(e) => setMois(e.target.value)}>
          <option disabled value="">Sélectionner un mois</option>
          {dispoMonths.map((month, i) => (
            <option key={i} value={month}>{moment.utc(month).locale('fr-FR').format('MMMM YYYY')}</option>
          ))}
        </TextField>

        <ButtonGroup variant="text" sx={{ "& .MuiButton-root": { color: "#4682B4" } }} disabled={selected.length===0 || !mois}>
          <Button onClick={()=>getRapport()}>Exporter le rapport</Button>
          <Button onClick={()=>getDepensesJrnl()}>Exporter le journal de dépenses</Button>
        </ButtonGroup>
      </Box>

      <TextField label="Rechercher une église" size="small" sx={{ mx:3, alignSelf:'center', width:'60%', minWidth: '300px' }} value={search} onChange={(e) => setSearch(e.target.value)} />

      <div style={{marginInline:'30px'}}><SorTableCheckable data={clotures.filter(log=> normalize(get_searchable(log)).includes(normalize(search)))} selectItems={selected} setItems={setSelected} table={table} rowsPerPage={50} rowsPerPageOptions={[25, 50, 100, 300]}/></div>

      {cloturesAnnuelles.length > 0 && <>
        <Box sx={{ mx: 3, mt: 4, mb: 1, borderTop: 1, borderColor: 'divider', pt: 3 }}>
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <Typography variant="h5">Export annuel {exercice}</Typography>
            <Stack direction='row' spacing={1} alignItems='center'>
              <Chip label={`${cloturesAnnuelles.length} église(s) — 12/12 mois clôturés`} color='success' size='small'/>
              <ButtonGroup variant="text" sx={{ "& .MuiButton-root": { color: "#4682B4" } }} disabled={selectedAnnuel.length === 0}>
                <Button onClick={getRapportAnnuel}>Exporter le rapport annuel</Button>
                <Button onClick={getDepensesAnnuelJrnl}>Exporter le journal de dépenses annuel</Button>
              </ButtonGroup>
            </Stack>
          </Stack>
        </Box>
        <div style={{marginInline:'30px'}}>
          <SorTableCheckable data={cloturesAnnuelles} selectItems={selectedAnnuel} setItems={setSelectedAnnuel} table={tableAnnuel} rowsPerPage={50} rowsPerPageOptions={[25, 50, 100]}/>
        </div>
      </>}

      <Backdrop open={load}><CircularProgress /></Backdrop>
    </Box>
  )
}
